import { render, staticRenderFns } from "./EgressProfileCompetenceMention.vue?vue&type=template&id=426b304a&scoped=true"
import script from "./EgressProfileCompetenceMention.vue?vue&type=script&lang=js"
export * from "./EgressProfileCompetenceMention.vue?vue&type=script&lang=js"
import style0 from "./EgressProfileCompetenceMention.vue?vue&type=style&index=0&id=426b304a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426b304a",
  null
  
)

export default component.exports